import React from 'react'
import PropTypes from 'prop-types'

import WithSimpleLightbox from 'Pods/Shared/WithSimpleLightbox'
import AttachmentImage from './AttachmentImage'
import AttachmentFile from './AttachmentFile'

const Attachments = ({ attachments, onImageClick }) => {
  let imageIndex = 0
  let fileIndex = 0

  return (
    <div className="attachments-section">
      {attachments.map((attachment) => {
        if (attachment.attributes.contentType === 'image') {
          const index = imageIndex
          imageIndex += 1

          return <AttachmentImage image={attachment} key={`${index}-image`} index={index} onImageClick={onImageClick} />
        }
        const index = fileIndex
        fileIndex += 1

        return <AttachmentFile file={attachment} key={`${index}-file`} />
      })}
    </div>
  )
}

Attachments.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      attributes: PropTypes.shape({
        contentType: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
  onImageClick: PropTypes.func.isRequired,
}

export default WithSimpleLightbox(Attachments)
